import { useSuspenseGetBillingInfo } from '@repo/api-codegen/v2';
import type { Plan } from '../interfaces/Plan';

interface SubscriptionStatus {
	plan: Plan | undefined;
	daysLeftInTrial: number;
	paywall: boolean;
	trial: boolean;
	isPayingCustomer: boolean;
}

export const usePlanNew = () => {
	const { data: billingInfo } = useSuspenseGetBillingInfo({});

	const subscriptionStatusLegacyFormat = {
		plan: {
			id: billingInfo?.plan_name?.toUpperCase(),
			title: billingInfo?.plan_name,
			integrations: billingInfo?.plan_integration_seats,
			extensions: billingInfo?.plan_extension_seats,
			viewers: billingInfo?.plan_viewer_seats,
			editors: billingInfo?.plan_editor_seats,
			legacy: false,
		} as Plan,
		daysLeftInTrial: billingInfo?.trial_days_remaining,
		paywall: billingInfo?.paywall,
		trial: billingInfo?.trial,
		isPayingCustomer:
			billingInfo?.plan_name && billingInfo?.plan_name !== 'Free',
	} as SubscriptionStatus;

	return subscriptionStatusLegacyFormat;
};

export const usePlan = usePlanNew;
